export default "__VITE_ASSET__9db141a2__"